export default "__VITE_ASSET__B82YUY_O__";